import React, { useState, useEffect } from 'react';
import InteractiveScoreboard from './components/InteractiveScoreboard';

function App() {
  const [players, setPlayers] = useState([]);
  const [games, setGames] = useState([]);
  const [selectedGame, setSelectedGame] = useState(null);
  const [menuView, setMenuView] = useState('potjes'); // 'potjes', 'scorebord', 'stats'

  useEffect(() => {
    fetch('/backend/api/players.php')
      .then(res => res.json())
      .then(setPlayers);
    fetch('/backend/api/games.php')
      .then(res => res.json())
      .then(setGames);
  }, []);

  const handleSelectGame = (game) => {
    setSelectedGame(game);
    setMenuView('scorebord');
  };

  const handleNewGame = () => {
    setSelectedGame(null);
    setMenuView('scorebord');
  };

  // Helper om spelersnamen te tonen
  const getPlayerName = (id) => {
    const p = players.find(pl => String(pl.id) === String(id));
    return p ? p.name : '';
  };
  const getGamePlayersString = (game) => {
    return `${getPlayerName(game.player1_id)} & ${getPlayerName(game.player3_id)} vs ${getPlayerName(game.player2_id)} & ${getPlayerName(game.player4_id)}`;
  };

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', background: '#fafafa', minHeight: '100vh', paddingBottom: 40 }}>
      <header style={{ padding: 16, textAlign: 'center', background: '#222', color: '#fff', marginBottom: 24 }}>
        <h1 style={{ fontSize: 38, margin: 0 }}>Klaverjas</h1>
        <nav style={{ marginTop: 16 }}>
          <button onClick={() => setMenuView('potjes')} style={{ fontSize: 20, margin: 8, padding: '8px 24px', background: menuView === 'potjes' ? '#ffe500' : '#fff', border: '2px solid #222', fontWeight: 'bold' }}>Potjes</button>
          <button onClick={() => setMenuView('scorebord')} style={{ fontSize: 20, margin: 8, padding: '8px 24px', background: menuView === 'scorebord' ? '#ffe500' : '#fff', border: '2px solid #222', fontWeight: 'bold' }}>Scorebord</button>
          <button onClick={() => setMenuView('stats')} style={{ fontSize: 20, margin: 8, padding: '8px 24px', background: menuView === 'stats' ? '#ffe500' : '#fff', border: '2px solid #222', fontWeight: 'bold' }}>Statistieken</button>
        </nav>
      </header>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        {menuView === 'potjes' && (
          <div style={{ marginBottom: 32 }}>
            <h2>Partijen</h2>
            <button onClick={handleNewGame} style={{ fontSize: 18, marginBottom: 8 }}>Nieuw potje</button>
            <table style={{ width: '100%', fontSize: 18, borderCollapse: 'collapse', background: '#fff' }}>
              <thead>
                <tr style={{ background: '#f3f3f3' }}>
                  <th style={{ border: '1px solid #888' }}>#</th>
                  <th style={{ border: '1px solid #888' }}>Datum</th>
                  <th style={{ border: '1px solid #888' }}>Spelers</th>
                  <th style={{ border: '1px solid #888' }}></th>
                </tr>
              </thead>
              <tbody>
                {games.map(game => (
                  <tr key={game.id} style={{ background: selectedGame && selectedGame.id === game.id ? '#e3f2fd' : '#fff' }}>
                    <td style={{ border: '1px solid #888', textAlign: 'center' }}>{game.id}</td>
                    <td style={{ border: '1px solid #888', textAlign: 'center' }}>{game.date ? game.date.substring(0, 16) : ''}</td>
                    <td style={{ border: '1px solid #888', textAlign: 'center' }}>{getGamePlayersString(game)}</td>
                    <td style={{ border: '1px solid #888', textAlign: 'center' }}>
                      <button onClick={() => handleSelectGame(game)} style={{ fontSize: 16 }}>Bekijk</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {menuView === 'scorebord' && (
          <InteractiveScoreboard
            players={players}
            game={selectedGame}
            onNewGameCreated={game => {
              setGames([game, ...games]);
              setSelectedGame(game);
            }}
          />
        )}
        {menuView === 'stats' && (
          <div>Statistieken komen hier (optioneel later uitwerken)</div>
        )}
      </div>
    </div>
  );
}

export default App;
